import React, { ReactNode, useCallback } from "react";

import useDebouncedCallback from "@mapmycustomers/shared/util/hook/useDebouncedCallback";
import { SearchField } from "@mapmycustomers/ui";

import useAnalytics from "@app/util/contexts/useAnalytics";

import styles from "./RecordListSearch.module.scss";

interface Props {
  actions?: ReactNode;
  onSearch: (query: string) => void;
  placeholder?: string;
}

const RecordListSearch: React.FC<Props> = ({ actions, onSearch, placeholder }) => {
  const analytics = useAnalytics();
  const handleSearch = useCallback(
    (query: string) => {
      onSearch(query);
      analytics.using(["Search"]);
    },
    [analytics, onSearch]
  );
  const handleChange = useDebouncedCallback(
    [handleSearch, 500, { trailing: true }],
    [handleSearch]
  );

  return (
    <div className={styles.container}>
      <SearchField
        allowClear
        className={styles.search}
        onChange={handleChange}
        placeholder={placeholder}
        size="middle"
      />
      {actions && <div>{actions}</div>}
    </div>
  );
};

export default RecordListSearch;
